export function initCmpModalFocus() {
    if (!window.tC) {
        const waitForVar = () => {
            if (window.tC) {
                attachListener();
            } else {
                setTimeout(waitForVar, 50);
            }
        };

        waitForVar();
    } else {
        attachListener();
    }
}

function attachListener() {
    window.tC?.eventTarget?.addEventListener?.('banner-show', () => {
        const modal = document.querySelector<HTMLElement>('#tc-privacy-wrapper');
        modal?.setAttribute('tabindex', '-1');
        modal?.focus();
    });
}
